/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {ActivatedRouteSnapshot} from '@angular/router';
import {PermitScreensManager} from './permit/permit-screens-manager.service';
import {ProfessionalLicenseScreensManager} from './professional-license/professional-license-screens-manager.service';
import {ScreensManager, ScreensManagerDeps} from '../../../../components/sections/service/screen-manager.class';
import {Step} from '../../../../components/sections/service/step.class';
import {Screen} from '../../../../components/sections/service/screen.class';

interface Parameters {
    index: string;
}

export enum ProfessionalStepScreens {
    PROFESSIONAL_LICENSE = 1,
    PERMIT
}

@Injectable()
export class ProfessionalStepScreensManager extends ScreensManager {

    private _currentScreen$ = new ReplaySubject<Screen>(1);
    screenChange$: Observable<boolean> = this._currentScreen$.map(() => true).publishReplay(1).refCount();

    constructor(smgm: ScreensManagerDeps,
                private readonly _professionalLicenseScreensManager: ProfessionalLicenseScreensManager,
                private readonly _permitScreensManager: PermitScreensManager) {
        super(smgm);

        this.refreshed$ = Observable.from([{refreshed$: this.refreshed$}, this._professionalLicenseScreensManager, this._permitScreensManager])
            .map(it => it.refreshed$).combineAll()
            .map(values => (values as Array<boolean>).every(it => it));
    }

    init(step: Step) {
        this._professionalLicenseScreensManager.init(step.idToScreenMap[ProfessionalStepScreens.PROFESSIONAL_LICENSE]);
        this._permitScreensManager.init(step.idToScreenMap[ProfessionalStepScreens.PERMIT]);
        super.init(step);
    }

    setCurrentScreen(screen: Screen, route: ActivatedRouteSnapshot) {
        super.setCurrentScreen(screen, route);
        let screenId = +screen.id;
        if (screenId === ProfessionalStepScreens.PROFESSIONAL_LICENSE) this._professionalLicenseScreensManager.setCurrentScreen(screen, route.firstChild);
        if (screenId === ProfessionalStepScreens.PERMIT) this._permitScreensManager.setCurrentScreen(screen, route.firstChild);
        this._currentScreen$.next(screen);
    }

    hasPreviousScreen(): boolean {
        let screenId = +this._currentScreen!.id;
        if (screenId === ProfessionalStepScreens.PROFESSIONAL_LICENSE) return this._professionalLicenseScreensManager.hasPreviousScreen();
        else return true;
    }

    hasNextScreen(): boolean {
        let screenId = +this._currentScreen!.id;
        if (screenId === ProfessionalStepScreens.PROFESSIONAL_LICENSE) return this._professionalLicenseScreensManager.hasNextScreen();
        else return true;
    }

    navigateToPreviousScreen(): Observable<boolean> {
        let screenId = +this._currentScreen!.id;
        if (screenId === ProfessionalStepScreens.PROFESSIONAL_LICENSE) {
            return this._permitScreensManager.skipFor(this._professionalLicenseScreensManager.itemIndex - 1)
                .flatMap(skip => {
                    if (!skip) return this._permitScreensManager.navigate(this._professionalLicenseScreensManager.itemIndex - 1);
                    else return this._professionalLicenseScreensManager.navigateToPreviousScreen();
                });
        }
        else return this._professionalLicenseScreensManager.navigateToScreen(this._permitScreensManager.professionalLicenseIndex);
    }

    navigateToNextScreen(): Observable<boolean> {
        let screenId = +this._currentScreen!.id;
        if (screenId === ProfessionalStepScreens.PROFESSIONAL_LICENSE) {
            return this._permitScreensManager.skipFor(this._professionalLicenseScreensManager.itemIndex)
                .flatMap(skip => {
                    if (!skip) return this._permitScreensManager.navigate(this._professionalLicenseScreensManager.itemIndex);
                    else return this._professionalLicenseScreensManager.navigateToNextScreen();
                });
        }
        else return this._professionalLicenseScreensManager.navigateToNextScreenFrom(this._permitScreensManager.professionalLicenseIndex);
    }

    navigateToFirstScreen(): Observable<boolean> { return this._professionalLicenseScreensManager.navigateToFirstScreen(); }

    navigateToLastScreen(): Observable<boolean> { return this._professionalLicenseScreensManager.navigateToLastScreen(); }

    protected _doRefresh(): Observable<any> { return Observable.of(true); }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/professional/professional-step-screens-manager.service.ts